export default {"src":"/_next/static/media/favicon.17e74a57.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};